import React from 'react';
import useReveal from '../../AIEmployees/useReveal';
import './SATestimonials.css';

/**
 * SATestimonials — real customer voices, recovered from the previous landing
 * page (git commit 673ee03e). Country+flag attribution (as the original).
 * Curated to the capability/breadth/competitor-comparison quotes that fit a
 * "why this super-agent" page; the off-message health quote was dropped.
 *
 * NOTE: these are real, previously-shipped quotes. Do not add invented ones —
 * if named/company attribution becomes available (with permission), upgrade
 * the attribution here.
 */
const QUOTES = [
  { quote: 'I tried AlphaSense, then used CellCog. So much better — surprised AlphaSense couldn’t do it.', flag: '🇺🇸', country: 'United States' },
  { quote: 'Ran the same prompt on Claude and CellCog. Claude: 7/10. CellCog: 8.5/10.', flag: '🇮🇳', country: 'India' },
  { quote: 'It’s like having an entire research team at your fingertips.', flag: '🇺🇸', country: 'United States' },
  { quote: 'It refined my creative ideas, then helped me execute them at light speed. Months of work, done in days.', flag: '🇮🇳', country: 'India' },
  { quote: 'Much better than Gemini or ChatGPT, especially for image and video generation.', flag: '🇫🇷', country: 'France' },
  { quote: 'CellCog blogs are ranking on SEO in record time.', flag: '🇮🇳', country: 'India' },
  { quote: 'Tried Perplexity Computer first, got frustrated. Then tried CellCog — it’s great.', flag: '🇺🇸', country: 'United States' },
];

const SATestimonials = () => {
  const [ref, visible] = useReveal();
  return (
    <section className="sa-tmo aie-section">
      <div className="aie-section-head">
        <h2 className="aie-section-title aie-display">What people build with it</h2>
        <p className="aie-section-sub">
          Real words from people putting CellCog to work on hard problems.
        </p>
      </div>
      <div className={`sa-tmo__grid aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        {QUOTES.map((t) => (
          <figure className="sa-tmo__card" key={t.quote}>
            <blockquote className="sa-tmo__quote">&ldquo;{t.quote}&rdquo;</blockquote>
            <figcaption className="sa-tmo__source">
              <span className="sa-tmo__flag" aria-hidden="true">{t.flag}</span>
              {t.country}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default SATestimonials;
